import { useAuth } from "@/context/AuthContext";
import { WarningOctagon, CreditCard, EnvelopeSimple, SignOut } from "@phosphor-icons/react";

export default function SuspendedScreen() {
  const { account, user, logout } = useAuth();
  const isOwner = account?.is_owner;
  const billingEmail = account?.billing_email;

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#0E0F3F" }} data-testid="suspended-screen">
      <div className="max-w-lg w-full text-center">
        <div className="w-16 h-16 rounded-2xl mx-auto flex items-center justify-center mb-6" style={{ background: "rgba(244,122,36,0.18)" }}>
          <WarningOctagon size={32} weight="fill" style={{ color: "#F37A24" }} />
        </div>
        <h1 className="font-heading font-black text-white text-3xl tracking-tight">Billing suspended</h1>
        <p className="text-white/65 mt-4 leading-relaxed">
          Your WorkWithLottie subscription has been paused due to an outstanding payment.
          Access to your ledgers, schedules and reports is temporarily unavailable.
        </p>

        {isOwner ? (
          <>
            <p className="text-white/65 mt-3 leading-relaxed">
              To restore access, please update your payment details and settle the outstanding balance.
            </p>
            <button
              onClick={() => alert("Redirecting to the Adfin payment portal… (integration coming soon)")}
              data-testid="suspended-update-payment"
              className="mt-7 inline-flex items-center gap-2 text-white font-semibold px-7 py-3.5 rounded-xl transition-transform hover:scale-[1.02]"
              style={{ background: "#F37A24" }}>
              <CreditCard size={20} weight="fill" /> Update payment &amp; pay outstanding
            </button>
            <p className="text-white/70 text-xs mt-3">You'll be taken to our secure payment provider (Adfin).</p>
          </>
        ) : (
          <div className="mt-6 rounded-xl border border-white/15 bg-white/5 p-4 text-left flex items-start gap-3" data-testid="suspended-managed-by">
            <EnvelopeSimple size={20} weight="fill" className="text-[#C2410C] shrink-0 mt-0.5" />
            <p className="text-sm text-white/80">
              This account's billing is managed by{" "}
              <a href={`mailto:${billingEmail}`} className="font-semibold text-white underline">{billingEmail}</a>.
              Please contact them to restore access.
            </p>
          </div>
        )}

        <button onClick={logout} data-testid="suspended-logout"
          className="mt-8 inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors mx-auto">
          <SignOut size={16} /> Sign out ({user?.email})
        </button>
      </div>
    </div>
  );
}
